var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q",class:[ _vm.direction ],attrs:{"id":_vm.id}},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[(_vm.active)?_c('div',{staticClass:"question-container"},[_c('div',{staticClass:"question"},[_c('div',{staticClass:"question-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }